import { useEffect } from "react";

/**
 * Hook that sets the document title
 */
export function useTitle(title?: string): void {
    useEffect(() => {
        if(typeof document !== "undefined") {
            if(title) {
                document.title = `${title} | Shopfront Developer`;
            } else {
                document.title = "Shopfront Developer";
            }
        }
    }, [ title ]);
}
